define( [
	"./cssExpand"
], function( cssExpand ) {
	"use strict";

	return new RegExp( cssExpand.join( "|" ), "i" );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/css/var/rboxStyle.js
 ** module id = 674
 ** module chunks = 0
 **/